import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID } from '@angular/core';
import { IconBsComponent, IconBsHandlers } from '@ui/elements/icon-bs/icon-bs.component';
import { WINDOW } from '@core/app/window.token';
import { isPlatformBrowser } from '@angular/common';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';


/**
 * Print icon control
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-print-control',
    templateUrl: './print-control.component.html',
    styleUrls: ['./print-control.component.scss'],
    imports: [
        IconBsComponent,
    ]
})
export class PrintControlComponent {
    readonly #window: Window = inject(WINDOW);
    readonly #platformId: Object = inject(PLATFORM_ID);

    public readonly handlers: IconBsHandlers = {
        handlerClick: (): void => {
            if (isPlatformBrowser(this.#platformId)) {
                this.#window.print();
            }
        },
    };

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;
}
